module.exports = __webpack_public_path__ + "img/Personal-o.9bc3be34.svg";